import withScroll from '../hoc/withScroll'
import onResize from '../utils/onResize'
import translate from '../utils/translations'

export default withScroll({
  name: 'page-nav',

  configuration: new Map([
    [
      'product', [
        { sliceClass: 'video-wrap', title: translate('PAGE_NAV_PRODUCT_VIDEO_WRAP') },
        { sliceClass: 'features', title: translate('PAGE_NAV_PRODUCT_FEATURES') },
        { sliceClass: 'spaces', title: translate('PAGE_NAV_PRODUCT_SPACES'), id: 'photos' },
        { sliceClass: 'millesime', title: translate('PAGE_NAV_PRODUCT_MILLESIME') },
        { sliceClass: 'virtual-tour', title: translate('PAGE_NAV_PRODUCT_VIRTUAL_TOUR') },
        { sliceClass: 'config-3d', title: translate('PAGE_NAV_PRODUCT_CONFIG_3D') }
      ]
    ],
    [
      'odsea', [
        { sliceClass: 'items-cols', title: translate('PAGE_NAV_ODSEA_SOLUTIONS'), position: 1, id: 'assets' },
        { sliceClass: 'items-cols', title: translate('PAGE_NAV_ODSEA_RENEWABLE_ENERGIES'), position: 2, id: 'renewable-energies' },
        { sliceClass: 'slice-scripts', title: translate('PAGE_NAV_ODSEA_SCRIPTS'), id: 'cruising-scenarios' },
        { sliceClass: 'other-products', title: translate('PAGE_NAV_ODSEA_OTHER_PRODUCTS') }
      ]
    ],
    [
      'carreers', [
        { sliceClass: 'slider-jobs', title: translate('PAGE_NAV_CARREERS_VIDEOS'), id: 'videos-metiers' },
        { sliceClass: 'offers', title: translate('PAGE_NAV_CARREERS_OFFRES'), id: 'offres' },
        { sliceClass: 'double-img-simple', title: translate('PAGE_NAV_CARREERS_FORMATIONS'), id: 'formations-itn' }
      ]
    ]
  ]),
  previousScroll: 0,

  ui: {
    mobilePanel: '[js-page-nav-mobile-panel]',
    toggleSummary: '[js-page-nav-toggle-summary]',
    mobilePanelBottom: '[js-page-nav-mobile-panel-bottom]',
  },

  events: [
    {
      on: 'click',
      target: 'toggleSummary',
      handle() {
        this.ui.toggleSummary.classList.toggle('is-opened')
        this.ui.toggleSummary.nextElementSibling.classList.toggle('is-opened')
      },
    },
  ],

  componentDidMount() {
    this.off = onResize(this.onResize.bind(this))

    const sliceClassCount = new Map()
    const slicesNavTitles = this.configuration.get(this.props.context)
    slicesNavTitles.forEach(entry => {
      const classCount = sliceClassCount.get(entry.sliceClass) ?? 0
      sliceClassCount.set(entry.sliceClass, classCount + 1)
    })

    const targetSliceClasses = Array.from(sliceClassCount.keys())
    const classSelectors = targetSliceClasses.map(cls => `section.slice.${cls}`).join(', ')
    const allElements = document.querySelectorAll(classSelectors)
    const foundSliceClasses = new Map()
    const elements = new Map()
    const foundSliceClassIndex = new Map()
    let minViewportElementHeightsRatio = .75
    allElements.forEach(element => {
      const currentSliceClass = Array.from(element.classList).find(cls => targetSliceClasses.includes(cls))
      const currentSliceClassIndex = foundSliceClassIndex.get(currentSliceClass) || 0
      foundSliceClassIndex.set(currentSliceClass, currentSliceClassIndex + 1)
      const foundClassCount = foundSliceClasses.get(currentSliceClass) ?? 0
      if (foundClassCount < sliceClassCount.get(currentSliceClass)) {
        const sliceNavOpt = slicesNavTitles.find(item => item.sliceClass === currentSliceClass && (item.position ? item.position === (currentSliceClassIndex + 1) : true)) || null
        if (sliceNavOpt) {
          element.id = element.id ? element.id : (sliceNavOpt.id ?? (sliceNavOpt.sliceClass + (sliceNavOpt.position ?? '')))
          elements.set(element.id, { element: element, options: sliceNavOpt })
          minViewportElementHeightsRatio = Math.min(minViewportElementHeightsRatio, Math.floor(window.innerHeight * 100 / element.offsetHeight) / 100)
          foundSliceClasses.set(foundClassCount + 1)
        }
      }
    })

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const menuItem = this.el.querySelector(`[data-page-nav-target="${entry.target.id}"]`)
          if (!menuItem.classList.contains('is-active')) {
            this.el.querySelectorAll('.page-nav__nav li').forEach((item) => item.classList.remove('is-active'))
            menuItem.classList.add('is-active')
          }
        }
      })
    }, {
      threshold: minViewportElementHeightsRatio - .03
    })

    let _this = this
    const menuNav = this.el.querySelector('.page-nav__nav')
    elements.forEach((value, key) => {
      observer.observe(value.element)

      const li = document.createElement('li')
      li.setAttribute('class', 'flex')
      li.setAttribute('js-page-nav-item', '')
      li.setAttribute('data-page-nav-target', key)
      li.textContent = value.options.title

      li.addEventListener('click', function () {
        value.element.scrollIntoView({ behavior: 'smooth' })

        const currentUrl = new URL(window.location)
        currentUrl.hash = key
        history.pushState(null, '', currentUrl)

        // Send a GTM event
        // window.dataLayer = window.dataLayer || []
        // window.dataLayer.push({
        //   event: 'scrollToAnchor',
        //   targetId: targetId
        // })

        setTimeout(function () {
          _this.closeMenu()
        }, 1000)
      })

      menuNav.appendChild(li)
    })

    if (window.location.hash) {
      const targetId = window.location.hash.replace('#', '')
      const targetElement = document.getElementById(targetId)
      if (targetElement) {
        targetElement.scrollIntoView({ behavior: 'smooth' })
        setTimeout(function () {
          _this.closeMenu()
        }, 1000)
      }
    }
  },

  componentWillUnmount() {
    this.off()
  },

  onResize() {
    this.productMenuHeight = this.el.offsetHeight

    let hero = null
    if (this.props.heroClass) {
      hero = document.querySelector(`.${this.props.heroClass}`)
    }

    this.heroOffsetBottom = hero ? hero.offsetTop + hero.offsetHeight : 32
  },

  onScroll({ y }) {
    if (y > this.heroOffsetBottom) {
      this.openMenu()
    } else {
      this.closeMenu()
    }

    this.previousScroll = y
  },

  openMenu() {
    this.el.classList.add('is-visible')
  },

  closeMenu() {
    this.ui.toggleSummary.nextElementSibling.classList.remove('is-opened')
    this.ui.toggleSummary.classList.remove('is-opened')
    let _this = this
    setTimeout(function () {
      _this.el.classList.remove('is-visible')
    })
  }
})
